module.exports = __webpack_public_path__ + "static/headshot-ben-hughes-3x.87b455b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-ben-hughes-3x.jpg
// module id = 118
// module chunks = 35783957827783 152909308826437